import { Fragment } from "react/jsx-runtime";
import { Href } from "../../../../../Constants/Constants";
import { ChatContactSettingListData } from "../../../../../Data/Messenger/Messenger";
import { useAppDispatch } from "../../../../../ReduxToolkit/Hooks";
import { setNewModal } from "../../../../../ReduxToolkit/Reducers/Messenger/Messenger";
import { ChatContactSettingType } from "../../../../../Types/MessengerType";
import CallModal from "./CallModal";
import ChatModal from "./ChatModal";
import ContactModal from "./ContactModal";

const ChatContactSetting: React.FC<ChatContactSettingType> = ({ chatContact, setChatContact }) => {
  const dispatch = useAppDispatch();
  return (
    <Fragment>
      <ul className={`chat-cont-setting ${chatContact ? "open" : ""}`} onClick={setChatContact}>
        {ChatContactSettingListData.map((item, index) => (
          <li key={index}>
            <a href={Href} onClick={() => dispatch(setNewModal(index))}>
              <div className={`icon-btn btn-outline-${item.color} button-effect btn-sm`}>{item.icon}</div>
              <span>{item.title}</span>
            </a>
          </li>
        ))}
      </ul>
      <ChatModal />
      <CallModal />
      <ContactModal />
    </Fragment>
  );
};

export default ChatContactSetting;
